// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pageRoot[data-v-6f5cdd60]
	{
		margin: 8px;
}
.heading[data-v-6f5cdd60]
	{
		font-size: 20px;
		border-bottom: 1px solid #000000;
		margin-bottom: 10px;
		margin-top: 30px;
		max-width: 400px;
}
.heading[data-v-6f5cdd60]:first-child
		{
			margin-top: 0px;
}
.bodySection[data-v-6f5cdd60]
	{
		margin: 0px 20px;
}
`, "",{"version":3,"sources":["webpack://./www/vues/admin/UserLoginHistory.vue"],"names":[],"mappings":";AA8BC;;EAEC,WAAW;AACZ;AAEA;;EAEC,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AACjB;AAEC;;GAEC,eAAe;AAChB;AAED;;EAEC,gBAAgB;AACjB","sourcesContent":["<template>\r\n\t<div class=\"pageRoot\">\r\n\t\t<div class=\"heading\">Login History for UserId {{userId}}</div>\r\n\t\t<div class=\"bodySection\">\r\n\t\t\t<LoginRecordsTable :userId=\"userId\" />\r\n\t\t</div>\r\n\t\t<div class=\"heading\">User Activity Logs for UserId {{userId}}</div>\r\n\t\t<div class=\"bodySection\">\r\n\t\t\t<UserActivityTable :userId=\"userId\" />\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport LoginRecordsTable from 'appRoot/vues/common/loginrecords/LoginRecordsTable.vue';\r\n\timport UserActivityTable from 'appRoot/vues/common/useractivity/UserActivityTable.vue';\r\n\r\n\texport default {\r\n\t\tcomponents: { LoginRecordsTable, UserActivityTable },\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tuserId: {\r\n\t\t\t\ttype: Number,\r\n\t\t\t\tdefault: 0\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.pageRoot\r\n\t{\r\n\t\tmargin: 8px;\r\n\t}\r\n\r\n\t.heading\r\n\t{\r\n\t\tfont-size: 20px;\r\n\t\tborder-bottom: 1px solid #000000;\r\n\t\tmargin-bottom: 10px;\r\n\t\tmargin-top: 30px;\r\n\t\tmax-width: 400px;\r\n\t}\r\n\r\n\t\t.heading:first-child\r\n\t\t{\r\n\t\t\tmargin-top: 0px;\r\n\t\t}\r\n\r\n\t.bodySection\r\n\t{\r\n\t\tmargin: 0px 20px;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
